import {ListingFileData} from "../types/listing-file-data.types";
import {defaultFileParams} from "../../../../../../../core/models/default-file-params";

export const defaultListingFileData: ListingFileData = {
  id: 0,
  fileName: '',
  file: defaultFileParams,
  usp: '',
  uspPriority: 1,
  history: []
}
